import { IAbookTab } from '@models/Forms/IForms';
import { resolveDocumentAbookTabs } from '@utils/abookTabVisibility';
import { useResolvedAbookTabs } from './useResolvedAbookTabs';

/** Вкладки окна выбора действия без формы: условия считаются по сохранённым значениям документа `docId`. */
export const useDocumentAbookTabs = (docId: string | undefined, tabs: IAbookTab[] | undefined) =>
    useResolvedAbookTabs(tabs, (source) => resolveDocumentAbookTabs(docId, source), docId);
